export const API_FAILED_TITLE = 'Attention';
export const API_FAILED_CONTENT =
  "We're sorry, but an unexcepted error has occured. Please try again.";
export const API_FAILED_CONTENTSECOND = 'Please try again';
export const OK = 'OK';
export const CANCEL_BTN = 'Cancel';
export const SIZE = 3;
export const boldWords: Array<string> = ['Benefits', 'Medical'];
export const ENGEN = 'engen';
export const ANALYTICS_PRODUCT_AREA = 'Copay only plan';
export const ANALYTICS_SCREEN_NAME = 'Custom Home Page';
export const ANALYTICS_WELCOME = 'welcome';
export const ANALYTICS_COST = 'costs';
export const ANALYTICS_PERKS = 'perks';
export const ANALYTICS_ABOUT = 'about';
export const ANALYTICS_NEXT_STEP = 'next step';
export const ANALYTICS_FINAL_STEP = 'final step';
